module.exports = __webpack_public_path__ + "img/languageOne.748721f2.png";